import { render } from "./CertificateApproveList.vue?vue&type=template&id=edf3a6fa&scoped=true"
import script from "./CertificateApproveList.vue?vue&type=script&lang=ts"
export * from "./CertificateApproveList.vue?vue&type=script&lang=ts"

import "./CertificateApproveList.vue?vue&type=style&index=0&id=edf3a6fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-edf3a6fa"

export default script